import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateChargingConnectorChargingRate } from '../../api/charging-connector.ts';
import { UpdateChargingConnectorChargingRateRequest } from '../../api/requests/charging-connector-request.ts';

export default function useUpdateChargingConnectorChargingRate(): UseMutationResult<
  Awaited<ReturnType<typeof updateChargingConnectorChargingRate>>,
  Error,
  UpdateChargingConnectorChargingRateRequest
> {
  return useMutation({
    mutationFn: updateChargingConnectorChargingRate,
  });
}
